<template>    
    <div class="py-4 container-fluid">
        <div class="card mb-5" ref="pdfContent">
            <div class="row mb-5">
                <div class="col-lg-12">
                    <div class="card-header p-3 pt-2">
                        <img
                            :src="isLoading ? loadingImageUrl : associationLogoImageSrc"
                            :alt="$t('association.Logo_image')"
                            style="width: 200px;"
                            />  
                        <h6 class="mb-2">{{ animal.associationName }}</h6>
                    </div>
                </div>
                <!-- LEFT: animal overview -->
                <div class="col-lg-4">
                    <div class="card-header p-3 pt-2">
                        <h4>Overzicht afstamming van</h4>
                        <div>
                            <dl class="row mb-0 small">
                                <dt class="col-6 text-muted">Stamboeknummer: </dt><dd class="col-6 line-height-20">{{ animal.studbookNumber }}&nbsp;</dd> 
                                <dt class="col-6 text-muted">Levensnummer: </dt><dd class="col-6 line-height-20">{{ animal.tagNumber }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Landcode: </dt><dd class="col-6 line-height-20">{{ animal.countryCode }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Ras:  </dt><dd class="col-6 line-height-20">{{ animal.breedName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Kleur: </dt><dd class="col-6 line-height-20">{{ animal.colorName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Naam: </dt><dd class="col-6 line-height-20">{{ animal.animalName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geslacht: </dt><dd class="col-6 line-height-20">{{ animal.gender }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geboortedatum: </dt><dd class="col-6 line-height-20">{{ animal.birthDate }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Worpgrootte: </dt><dd class="col-6 line-height-20">{{ animal.litterSize }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal worpen: </dt><dd class="col-6 line-height-20">{{ animal.noParities }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal lammeren: </dt><dd class="col-6 line-height-20">{{ animal.noLambs }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Scrapie: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Zwoeger: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName2 }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Stamboeksectie: </dt><dd class="col-6 line-height-20">{{ animal.studebookSectionDescription }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Status: </dt><dd class="col-6 line-height-20">{{ animal.studebookStatus }}&nbsp;</dd>
                                                                
                                <!-- KEURSTW -->
                                <template v-for="attr in keurstwItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <!-- KEURPNT -->
                                <template v-for="attr in keurpntItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <dt class="col-6 text-muted">Fokker: </dt><dd class="col-6 line-height-20">{{ animal.breederName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Houder: </dt><dd class="col-6 line-height-20">{{ animal.keeperName }}&nbsp;</dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <!-- RIGHT: pedigree L→R rows with brackets -->
                <div class="col-lg-8">
                    <!-- Row 1: FATHER side -->
                    <div class="ped-row mb-5">
                        <!-- left: father card -->
                        <div class="ped-left">                            
                            <PedigreeCard
                            v-if="pedigree1?.selectedanimal?.father"
                            :node="pedigree1.selectedanimal.father"
                            label="Vader"
                            :id="pedigree1.selectedanimal.father.id"
                            :style="{ marginTop: '90% !important' }"
                            />
                            <span class="to-mid"></span>
                        </div>

                        <!-- middle: vertical bracket -->
                        <div class="ped-mid">
                            <div class="spine" style="top: 30% !important;">
                                <span class="arm top"></span>
                                <span class="arm bottom"></span>
                            </div>
                        </div>

                        <!-- right: father’s parents + their parents -->
                        <div class="ped-right">
                            <!-- father’s father branch -->
                            <div v-if="pedigree1.selectedanimal.father?.father" class="branch">
                                <div class="parent">
                                    <PedigreeCard                                    
                                    :node="pedigree1.selectedanimal.father.father"
                                    label="Vader"
                                    :id="pedigree1.selectedanimal.father.father.id"
                                    />                                    
                                </div>
                                <div class="spine">
                                    <span class="arm top"></span>
                                    <span class="arm bottom"></span>
                                </div>
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.father"
                                            :node="pedigree1.selectedanimal.father.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.father.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.mother"
                                            :node="pedigree1.selectedanimal.father.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.father.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- father’s mother branch -->
                            <div v-if="pedigree1.selectedanimal.father?.mother" class="branch mt-4">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.father.mother"
                                    label="Moeder"
                                    :id="pedigree1.selectedanimal.father.mother.id"
                                    />                            
                                </div>
                                <div class="spine">
                                    <span class="arm top"></span>
                                    <span class="arm bottom"></span>
                                </div>
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.father"
                                            :node="pedigree1.selectedanimal.father.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.mother.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.mother"
                                            :node="pedigree1.selectedanimal.father.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.mother.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>

                    <!-- Row 2: MOTHER side -->
                    <div class="ped-row">
                        <!-- left: mother card -->
                        <div class="ped-left">
                            <PedigreeCard
                            v-if="pedigree1?.selectedanimal?.mother"
                            :node="pedigree1.selectedanimal.mother"
                            label="Moeder"
                            :style="{ marginTop: '90%' }"
                            :id="pedigree1.selectedanimal.mother.id"
                            />
                            <span class="to-mid"></span>
                        </div>

                        <!-- middle: vertical bracket -->
                        <div class="ped-mid">
                            <div class="spine">
                                <span class="arm top"></span>
                                <span class="arm bottom"></span>
                            </div>
                        </div>
                        
                        <!-- right: mother’s parents + their parents -->
                        <div class="ped-right">
                            <!-- mother’s father branch -->
                            <div v-if="pedigree1.selectedanimal.mother?.father" class="branch">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.mother.father"
                                    label="Vader"
                                    :id="pedigree1.selectedanimal.mother.father.id"
                                    />
                                </div>
                                <div class="spine">
                                    <span class="arm top"></span>
                                    <span class="arm bottom"></span>
                                </div>
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.father"
                                            :node="pedigree1.selectedanimal.mother.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother.father.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.mother"
                                            :node="pedigree1.selectedanimal.mother.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother.father.monther.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- mother’s mother branch -->
                            <div v-if="pedigree1.selectedanimal.mother?.mother" class="branch mt-4">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.mother.mother"
                                    label="Moeder"
                                    :id="pedigree1.selectedanimal.mother.mother.id"
                                    />                            
                                </div>
                                <div class="spine">
                                    <span class="arm top"></span>
                                    <span class="arm bottom"></span>
                                </div>
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.father"
                                            :node="pedigree1.selectedanimal.mother.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother.mother.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vander"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.mother"
                                            :node="pedigree1.selectedanimal.mother.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother.mother.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
            </div>
        </div>        
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link v-if="!isEmbedded" to="/animal" class="btn btn-sm bg-gradient-danger float-start  ms-2">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 me-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import { defineComponent, h } from 'vue';
import loadingImageUrl from '@/assets/img/LoadingImage.gif'
import noImageUrl from '@/assets/no-image.png'
import html2canvas from 'html2canvas';
import { useRouter } from 'vue-router';

const PedigreeCard = defineComponent({
  name: 'PedigreeCard',
  props: { node: { type: Object, required: true }, label: { type: String, default: '' }, level: { type: Number, default: 0 }, id: { type: String, required: true } },
  setup(props) {
    const router = useRouter()

    const goToPreview = () => {
      if (props.id) {
        router.push({ 
            name: 'Preview Animal', 
            params: { id: props.id },
            query: { call: 'pedigree' }
        })
      }
    }

    return () =>
      h('div', { class: ['card','card-node','border-0','shadow-sm','text-nowrap'] }, [
        h('div', {
          class: ['card-header','card-header-custom','py-1','px-2','fw-semibold', props.node?.gender === 'M' ? 'bg-male text-white' : 'bg-female text-white'],
           style: { fontSize: '18px !important', padding: '11px !important', paddingLeft: '21px !important' }
        }, props.label || (props.node?.gender === 'M' ? 'Vader' : 'Moeder'),
            h(
                'a',
                {
                    class: 'ms-3 float-end', 'data-hide-pdf': 'true',
                    title: 'Voorbeeld',
                    style: { cursor: 'pointer' },
                    onClick: goToPreview
                },
                [
                    h('i', {
                    class: 'material-symbols-rounded opacity-10 text-white',
                    style: { fontSize: '1.2rem' },
                    ariaHidden: 'true'
                    }, 'table_eye')
                ]
            )
        ),
        h('div', { class: 'card-body p-2 small' }, [
        
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Stamboeknummer: '),

            props.node?.id
                ? h('a',
                    {
                        href: `/animal/pedigree/${props.node.id}`,                        
                        style: {
                            color: '#0f8d09',
                            textDecoration: 'none'
                        }
                    },
                    props.node?.studbooknumber ?? '—'
                )
                : (props.node?.studbooknumber ?? '—')
        ]),


        // single row: studbook | tag | country
        h('div', { class: 'fw-semibold mb-1' }, [            
            h('span', { class: 'fw-bold' }, 'Levensnummer: '),
            props.node?.tagnumber || '—',
            ' | ',
            props.node?.countrycode || '—'
        ]),
           
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Naam: '),
            props.node?.name || '—'
        ]),

        // single row: birthdate | siblings | gender | genotype
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Geboortedatum: '),
            props.node?.birthdate || '—'    
        ]),

         h('div', { class: 'fw-semibold mb-1' }, [                      
            h('span', { class: 'fw-bold' }, 'Genotype: '),
            props.node?.genotype || '—'
        ]),

        // single row: nobirths | nolambs
        h('div', { class: 'fw-semibold mb-1' }, [            
            h('span', { class: 'fw-bold' }, 'Worpgrootte: '),
            props.node?.siblings ?? '—',
            ' | ',        
            h('span', { class: 'fw-bold' }, 'Worpen: '),
            props.node?.nobirths ?? '—',
            ' | ',
            h('span', { class: 'fw-bold' }, 'Lammeren: '),
            props.node?.nolambs ?? '—'
        ]),
                
        h('table', { class: 'table table-sm table-bordered text-center mt-2' }, [
        h('tbody', {}, [
            // First header row
            h('tr', {}, [
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'HF'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'HO'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'NE'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'VH'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'MH')
            ]),
            // First value row
            h('tr', {}, [
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nolambs || '—')
            ]),

            // Second header row
            h('tr', {}, [
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'AH'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'BW'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'ST'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'HV'),
            h('th', { class: 'bg-light text-dark', style: 'font-size: 12px !important;' }, 'AV')
            ]),
            // Second value row
            h('tr', {}, [
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nobirths || '—'),
            h('td', { style: 'border-width: 1px;font-size: 12px !important;' }, props.node?.nolambs || '—')
            ])
        ])
        ]),
        

        //h('div', { class: 'text-muted mb-2' }, props.node?.id),
        //  props.node?.genotype ? h('div', { class: 'badge bg-light text-dark mb-2' }, `Genotype: ${props.node.genotype}`) : null,
        //  props.node?.details
        //    ? h('dl', { class: 'row g-1 mb-0 small' },
        //        Object.entries(props.node.details).flatMap(([k,v]) => [
        //          h('dt', { class: 'col-5 text-muted' }, k),
        //          h('dd', { class: 'col-7' }, String(v))
        //        ])
        //      )
        //    : null
        ])
      ])
  }
})


const PedigreeCardNoData = defineComponent({
  name: 'PedigreeCardNoData',
  props: { node: { type: Object, required: true }, label: { type: String, default: '' }, level: { type: Number, default: 0 } },
  setup(props) {
    return () =>
      h('div', { class: ['card','card-node','border-0','shadow-sm','text-nowrap'] }, [
        h('div', {
          class: ['card-header','card-header-custom','py-1','px-2','fw-semibold', props.label === 'Vader' ? 'bg-male text-white' : 'bg-female text-white'],
           style: { fontSize: '18px !important', padding: '4px 4px 4px 21px !important' }
        }, props.label || (props.node?.gender === 'M' ? 'Vader' : 'Moeder')),
        h('div', { class: 'card-body p-2 small' }, [
        
        // single row: studbook | tag | country
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Geen gegevens gevonden')
        ]),
        ])
      ])
  }
})

/* ============================================================ */

export default {
    name: 'Pedigree_page',    
    components: { PedigreeCard, PedigreeCardNoData },
    data() {
        return {            
            animalId: '',
            associationLogoImageSrc: noImageUrl,
            isLoading: false,
            loadingImageUrl,
            animal: { keurstw: { items: [] }, keurpnt : { items: [] } },
            gets: [],            
            pedigree1: {  
                selectedanimal: {
                    id: 'TAG-0001',
                    name: 'De Hoop Willemien',
                    father: {
                        studbooknumber: '00GDA-92231',
                        tagnumber: '100059592231',
                        countrycode: 'NL',
                        name: 'Vader A',
                        birthdate: '23-10-2025',
                        siblings: 1,
                        gender: 'M',
                        id: 'TAG-1001',
                        genotype: 'ARR/ARR',
                        nobirths: 3,
                        nolambs: 6,                        
                        father: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'M',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6
                        },
                        mother: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'F',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6, 
                        }
                    },
                    mother: {
                        studbooknumber: '00GDA-92231',
                        tagnumber: '100059592231',
                        countrycode: 'NL',
                        name: 'Moeder B',
                        birthdate: '23-10-2025',
                        siblings: 1,
                        gender: 'M',
                        id: 'TAG-1001',
                        genotype: 'ARR/ARR',
                        nobirths: 3,
                        nolambs: 6,                        
                        father: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'M',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6
                        },
                        mother: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'F',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6, 
                        }
                    }
                }
            }
        }
    },
    computed: {
        isEmbedded() {
            return this.$route.query.embed === 'true';
        },

        keurstwItems() {
        return (this.animal && this.animal.keurstw && Array.isArray(this.animal.keurstw.items))
            ? this.animal.keurstw.items
            : [];
        },
        keurpntItems() {
        return (this.animal && this.animal.keurpnt && Array.isArray(this.animal.keurpnt.items))
            ? this.animal.keurpnt.items
            : [];
        }
    },
    async mounted() {        
        try {            
            this.animalId = this.$route.params.id;            
            console.log(this.animalId);
            await this.fetchAnimalPedigree(this.animalId);
            
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
    },    
    methods: {   
        coercePedigree(input) {
            if (!input) return null;

            // Case A: already an object
            if (typeof input === 'object') {
                const root = input.pedigree ?? input; // flatten if it has .pedigree
                return root?.selectedanimal ? { selectedanimal: root.selectedanimal } : null;
            }

            // Case B: string like "pedigree: { selectedanimal: {...} }"
            if (typeof input === 'string') {
                // Make it JSON-ish: quote keys, switch single->double quotes
                const jsonish = input
                .replace(/(\w+)\s*:/g, '"$1":') // quote keys
                .replace(/'/g, '"');            // single -> double quotes

                // Ensure it’s wrapped in braces if not already
                const wrapped = /^\s*\{/.test(jsonish) ? jsonish : `{${jsonish}}`;

                try {
                const obj = JSON.parse(wrapped);
                const root = obj.pedigree ?? obj;
                return root?.selectedanimal ? { selectedanimal: root.selectedanimal } : null;
                } catch {
                return null;
                }
            }

            return null;
        }, 
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        },
        normalizeAnimalData(raw) {
            const a = raw || {};
            const safeItems = (group) => (group && Array.isArray(group.items)) ? group.items : [];
            return {
                ...a,
                keurstw: { items: safeItems(a.keurstw) },
                keurpnt: { items: safeItems(a.keurpnt) }
            };
        },        
        async fetchAnimalPedigree(animalId) {
            try {
                this.isLoading = true;
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("Animal/getpedigree", {
                                params: {
                                    animalId
                                }})

                this.gets = response.data;

                if (this.gets.success) {                    
                    //this.animal = this.gets.data;
                    this.animal = this.normalizeAnimalData(this.gets.data);                    
                    //this.animal.logoDataUrl

                    let logoSrc = this.animal?.logoDataUrl || '';
                    if (!logoSrc && this.animal?.logoBase64 && this.animal?.contentType?.startsWith('image/')) {
                        logoSrc = `data:${this.animal.contentType};base64,${this.animal.logoBase64}`;
                    }

                    this.associationLogoImageSrc = logoSrc || noImageUrl;  
                    this.isLoading = false;   
                    
                    try {
                        this.pedigree1 = this.coercePedigree(this.animal?.pedigree);
                        console.log('parsed pedigree:', this.pedigree1);
                    } catch (err) {
                        console.error('coercePedigree error:', err);
                    }                    
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }  finally {
                this.isLoading = false;
                this.$store.commit('setShowLoading', false);
            }      
        },   
        async downloadPdf() {
            const root = this.$refs.pdfContent;
            if (!root) return;

            await this.$nextTick();

            // Hide preview buttons
            const hidden = [];
            root.querySelectorAll('[data-hide-pdf]').forEach(el => {
                hidden.push({ el, display: el.style.display });
                el.style.display = 'none';
            });

            // VERY IMPORTANT: capture FULL real size
            const fullWidth  = root.scrollWidth;
            const fullHeight = root.scrollHeight;

            // Temporarily remove any overflow limits
            const oldOverflow = root.style.overflow;
            root.style.overflow = 'visible';

            // Capture ENTIRE content (not viewport width)
            const canvas = await html2canvas(root, {
                backgroundColor: '#ffffff',
                useCORS: true,
                scale: 2,
                width: fullWidth,
                height: fullHeight,
                windowWidth: fullWidth,
                windowHeight: fullHeight,
            });

            // Restore layout
            root.style.overflow = oldOverflow;
            hidden.forEach(({ el, display }) => {
                el.style.display = display;
            });

            const imgData = canvas.toDataURL('image/png');

            // Create A4 landscape PDF
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const pageW = pdf.internal.pageSize.getWidth();
            const pageH = pdf.internal.pageSize.getHeight();

            const imgW = canvas.width;
            const imgH = canvas.height;

            // Scale so NOTHING is clipped
            const scale = Math.min(pageW / imgW, pageH / imgH);

            const renderW = imgW * scale;
            const renderH = imgH * scale;

            // Center horizontally, small top margin
            const x = (pageW - renderW) / 2;
            const y = 5;

            pdf.addImage(imgData, 'PNG', x, y, renderW, renderH);

            pdf.save('Pedigree.pdf');
        },
        async downloadPdf1() {
            const root = this.$refs.pdfContent;
            if (!root) return;

            await this.$nextTick();

            // Grab existing, rendered DOM parts (no template changes needed)
            const headerEl  = root.querySelector('.row .col-lg-12 .card-header');
            const leftEl    = root.querySelector('.col-lg-4');   // left overview column
            const rightEl   = root.querySelector('.col-lg-8');   // pedigree column (right)

            if (!headerEl || !leftEl || !rightEl) {
                console.warn('Could not find required sections for PDF.');
                return;
            }

            // ---- 1) Build hidden staging area with two page-sized containers ----
            const staging = document.createElement('div');
            staging.style.position = 'fixed';
            staging.style.left = '-10000px';
            staging.style.top = '0';
            staging.style.width = '1122px';   // A4 landscape at ~96dpi
            staging.style.zIndex = '-1';

            // page factory
            const makePage = () => {
                const page = document.createElement('div');
                page.className = 'pdf-page a4-landscape';
                page.style.width = '1122px';
                page.style.minHeight = '793px';  // A4 landscape height at ~96dpi
                page.style.padding = '16px';
                page.style.boxSizing = 'border-box';
                page.style.background = '#ffffff';
                return page;
            };

            const page1 = makePage();
            const page2 = makePage();

            // Clone current rendered DOM (data already applied)
            const headerClone = headerEl.cloneNode(true);
            const leftClone   = leftEl.cloneNode(true);
            const rightClone  = rightEl.cloneNode(true);

            // Hide anything marked for PDF hiding inside clones
            const hideMarked = (root) => {
                if (!root) return;                
                root.querySelectorAll('[data-hide-pdf]').forEach(n => {
                    n.style.display = 'none';
                    // optionally: n.style.visibility = 'hidden';
                });
            };

            hideMarked(headerClone);
            hideMarked(leftClone);
            hideMarked(rightClone);

            // Assemble pages
            page1.appendChild(headerClone);
            page1.appendChild(leftClone);

            page2.appendChild(rightClone);

            staging.appendChild(page1);
            staging.appendChild(page2);
            document.body.appendChild(staging);

            // ---- 2) Snapshot each page separately ----
            const toCanvas = (el) =>
                html2canvas(el, {
                backgroundColor: '#ffffff',
                useCORS: true,
                scale: 2,
                windowWidth: el.scrollWidth || 1122,
                windowHeight: el.scrollHeight || 793,
                });

            const [canvas1, canvas2] = await Promise.all([toCanvas(page1), toCanvas(page2)]);
            const img1 = canvas1.toDataURL('image/png');
            const img2 = canvas2.toDataURL('image/png');

            // ---- 3) Compose the PDF (A4 landscape) ----
            const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
            const pageW = pdf.internal.pageSize.getWidth();
            const pageH = pdf.internal.pageSize.getHeight();

            const addImageFullPage = (src, canvas) => {
                const imgW = canvas.width;
                const imgH = canvas.height;
                const imgRatio = imgW / imgH;
                const pageRatio = pageW / pageH;

                let renderW = pageW, renderH = pageH;
                if (imgRatio > pageRatio) {
                renderW = pageW;
                renderH = pageW / imgRatio;
                } else {
                renderH = pageH;
                renderW = pageH * imgRatio;
                }
                const x = (pageW - renderW) / 2;
                const y = (pageH - renderH) / 2;
                pdf.addImage(src, 'PNG', x, y, renderW, renderH);
            };

            addImageFullPage(img1, canvas1);
            pdf.addPage();
            addImageFullPage(img2, canvas2);

            // ---- 4) Cleanup & save ----
            document.body.removeChild(staging);
            pdf.save('Pedigree.pdf');
        },     
    }
}
</script>
<style scoped>
    .line-height-20 { line-height: 20px; }

    .pdf-page.a4-landscape {
        width: 1122px;
        min-height: 793px;
        padding: 16px;
        box-sizing: border-box;
        background: #fff;
    }

    .no-data-box {
        border: 2px solid red;
        padding: 1rem;
        border-radius: 6px;
        color: red;
        text-align: center;
        font-weight: 500;
    }

    /* grid for each branch (parent | spine | children) */
    .branch {
    display: grid;
    grid-template-columns: minmax(280px, auto) 36px minmax(280px, 1fr);
    align-items: center;
    column-gap: 16px;
    }

    /* connector column with vertical line + two horizontal arms */
    .branch .spine { position: relative; align-self: stretch; }
    .branch .spine::before {
    content: ""; position: absolute; left: 50%; top: 0; bottom: 0;
    width: 2px; transform: translateX(-50%); background: #d9dee3;
    }
    .branch .spine .arm { position: absolute; left: 50%; width: 24px; height: 2px; background: #d9dee3; transform: translateX(-1px); }
    .branch .spine .arm.top { top: 25%; }
    .branch .spine .arm.bottom { bottom: 25%; }

    .branch .children { display: grid; grid-auto-rows: 1fr; row-gap: 24px; }

    /* global colors used by card headers */
    :global(.bg-male){ background:#4e61d3 !important; }
    :global(.bg-female){ background:#d63384 !important; }
  
    /* consistent sizing for your cards */
    .card-node{ width:100%;  }

    /* --- L→R row layout --- */
    .ped-row{
        display: flex;
        align-items: stretch; 
    }

    /* left column (parent card) + short line to middle */
    .ped-left{
        position:relative;
        margin-right:7px;
    }
    .ped-left .to-mid{
        position:absolute;
        right:-28px;
        top:50%;
        transform:translateY(-50%);
        width:28px; height:2px; background:#dfe3e8;
    }

    /* middle narrow column with vertical bracket */
    .ped-mid{
        position:relative;
        width:24px;
        margin-right:28px;
    }    
    .ped-mid .spine{
        position: absolute;
        left: 94%;
        transform: translateX(-50%);
        top: 115px;
        height: 52.5%;
        bottom: 0;
        width: 2px;
        background: #dfe3e8;
    }

    /* right column: two stacked pair boxes */
    .ped-right{
        position:relative;
        display:flex; flex-direction:column;
    }

    .ped-right-item {
        position: relative;
        display: inline-block;
    }

    .ped-right-item .to-mid {
        position: absolute;
        left: -28px;
        top: 50%;
        transform: translateY(-50%);
        width: 28px;
        height: 2px;
        background: #dfe3e8;
    }
    .pair-card{
        position:relative;
        background:#fff;
        border-radius:.5rem;
        box-shadow:0 6px 20px rgba(0,0,0,.07);
        padding:.75rem 1rem;
        min-width:300px;
    }
    .pair-title{ font-weight:600; }

    /* small line from each pair box into the middle spine */
    .pair-card .to-mid{
        content:"";
        position:absolute;
        left:-28px;
        top:50%;
        transform:translateY(-50%);
        width:28px; height:2px; background:#dfe3e8;
    }
</style>